// extracted by mini-css-extract-plugin
export default {"popupBody":"Notification_popupBody__Hoi+p","closeBtn":"Notification_closeBtn__aQVIT"};